import React, {useEffect, useState} from "react";
import axios from "axios";
import Select from "react-select";
import "./SelectInput.css"
import BasicLoader from "../BasicLoader/BasicLoader";
import LoadingButton from "@mui/lab/LoadingButton";
import RefreshIcon from '@mui/icons-material/Refresh';

const SelectInput = ({
                         url, list, set, setObj,
                         defaultValue, returnList,
                         placeholder, required, getLabel,
                         getValueForList, maxMenuHeight,
                         isClearable, readContent,
                         hideRefresh,
                         className = ''
                     }) => {


    const [loadData, setLoadData] = useState(true)

    let listMapped = []
    const [select, setSelect] = useState(false)
    const [loading, setLoading] = useState(true)

    const [marginBottom, setMarginBottom] = useState('100%')

    useEffect(() => {
        if (loadData) {
            setLoading(true)
            axios.get(url, {
                params: {
                    sort: 'id,desc'
                }
            })
                .then(function (response) {
                    if (typeof readContent === 'function')
                        set(readContent(response.data))
                    else
                        set(response.data.content)
                    setLoading(false)
                }).catch(function (error) {
                console.log(error);
            }).finally(() => {
                setLoadData(false)
                setLoading(false)
            })
        }
    }, [loadData])

    useEffect(() => {
        if (list.length > 0) {
            if (typeof returnList === 'function') {
                listMapped = returnList()
            } else
                listMapped = defaultValues()

            let item

            if (defaultValue !== undefined && defaultValue !== '') {
                item = (listMapped.find(item => item.value === defaultValue))
                setObj(item?.value)
            }
            setSelect((<Select
                className="basic-single w-100"
                classNamePrefix="select"
                id="form_select"
                required={required}
                // defaultValue={listMapped.find(item => item.value === defaultValue)}
                defaultValue={item}
                isDisabled={false}
                isLoading={false}
                isClearable={isClearable}
                isRtl={false}
                isSearchable={true}
                options={listMapped}
                onChange={(e) => setObj(e?.value)}
                placeholder={placeholder}
                maxMenuHeight={maxMenuHeight}
                onMenuOpen={() => setMarginBottom('20%')}
                // onChange={(e) => setObj(e.target.value)}
                styles={{
                    menu: (base) => ({
                        ...base,
                        zIndex: 2
                    })
                }}
            />))
        }
    }, [list])

    const defaultValues = () => {
        let returnList = []
        list.forEach((item) => {
            // this function variable 'label' need to be passed
            // if you want to display a property different of 'name'
            // for the items of the list
            const label = getLabel ? getLabel(item) : item.name
            const value = getValueForList ? getValueForList(item) : item.id
            returnList.push({value, label})
        })
        return returnList
    }

    return (
        <>
            {!select ?
                (<>
                    <BasicLoader height={10} message={'Carregando dados...'}/>
                    <input type="text" name="block-submit" hidden required/>
                </>) :
                <>
                    <div className={'d-flex ' + className}>
                        {select}
                        {!hideRefresh &&
                            <LoadingButton
                                onClick={() => setLoadData(true)}
                                loading={loading}
                                loadingPosition="center"
                                color="inherit"
                                variant="outlined"
                                size="small"
                                sx={{
                                    minWidth: '38px',
                                    height: '38px',
                                    padding: 0,
                                    borderColor: '#afafaf',
                                    borderLeft: 'none',
                                    backgroundColor: 'transparent',
                                }}
                            >
                                {!loading && (
                                    <RefreshIcon sx={{ color: '#afafaf', fontSize: 20 }} /> // ajuste aqui a cor
                                )}
                            </LoadingButton>
                        }
                    </div>
                </>
            }
        </>
    )
}

export default SelectInput